import React from 'react';
import { inject, observer } from 'mobx-react';

var qs = require('qs')
@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class LandingPageIntroSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        // console.log("blog info", this.props.blogInfo)
        if (this.props.blogInfo) {
            // console.log("blog info", this.props.blogInfo)
            return (
                <div className="rectangle-featured-artworks blog-section" ref={(section) => {
                    this.categories = section;

                }} style={{ paddingBottom: "40px", backgroundColor: (this.props.colored) ? "#F5F5F5" : "#FFFF", width: "100%" }}>
                    <div style={{ display: "flex", width: "95%", margin: "0px auto" }}>

                        <div className="title-featured-artworks mt-15">
                            FROM THE BLOG
                        <hr className="line-category-name"></hr>
                        </div>

                    </div>

                    <div className="row" style={{ width: "95%", margin: "0px auto" }}>
                        <div className="col-md-7 pl-0">
                            <div className="blog-text mt-15">
                                <h2 className="blog-heading-text">
                                    {this.props.blogInfo.title}
                                </h2>
                                <p className="blog-desc" style={{ '-webkit-box-orient': 'vertical' }}>
                                    {this.props.blogInfo.description}
                                </p>

                                <div className="blog-btn-section">
                                    <a href={this.props.blogInfo.blog_url} target="_blank"><button className="masterpieces-primary-buttons button month-btn mt-15 mb-15">
                                        READ THE FULL STORY
                                </button></a>
                                </div>

                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="blog-img">
                                <img className="blog-image"
                                    src={this.props.blogInfo.image_url} />
                            </div>
                        </div>


                    </div>
                </div>
            )
        }
        else return <div></div>
    }
}


// WEBPACK FOOTER //
// ./src/components/sectionHolders/blogSection.js